import { Injectable } from '@angular/core';
import { BaseProvider } from '../../providers/base-provider';
import { ChatLayoutNotifier } from '../notifiers/chat-layout-notifier';
import { ChatLayoutState } from '../states/chat-layout-state';

@Injectable({ providedIn: 'root' })
export class ChatLayoutProvider extends BaseProvider<ChatLayoutNotifier, ChatLayoutState> {
  constructor() {
    super(ChatLayoutNotifier);
  }
}
